<script context="module">
function close() {
    document.getElementById("popup").style.display = "none";
}

export const title = "Eingetragene Impfungen";
export const message = "Alle derzeit verwendeten COVID-19 Impfstoffe werden in Mehrdosenbehältnissen geliefert. Die Zahl der Auslieferungen richtet sich nach der Zahl der entnehmbaren Impfdosen laut Fachinformation, das sind je nach Hersteller zwischen 6 und 10 Dosen pro Flasche (Vial). Durch spezielle Spritzen mit Spardorn, die in Österreich zum Einsatz kommen, ist es möglich, ohne Qualitätseinbußen zusätzliche Dosen aus den Vials zu entnehmen. So ist es möglich, dass mehr Impfungen im e-Impfpass eingetragen sind als Dosen laut Fachinformation ausgeliefert wurden.";

export function showPopup(importedTitle,importedMessage) {
    message = importedMessage;
    title = importedTitle;
    document.getElementById("popup").style.display = "block";
}
</script>

<div id="popup" class="popup">
    <div class="flex justify-between p-4 border-b border-gray-300 font-bold">
        <h4>{title}</h4>
        <button on:click={close}>
        <img src="/assets/icons/close.svg" alt="">
        </button>
    </div>
    <div class="p-4 popup-content">
    {message}
    </div>
</div>

<style>
.popup {
    @apply fixed bg-white z-50 shadow-lg border border-gray-300;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 56ch;
    max-width: 80vw;
    display: none;
}

.popup-content {
    max-height: 70vh;
    overflow: scroll;
}
</style>